import { createFileRoute } from '@tanstack/react-router';
import { Segmented } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TagButton } from '@/elements';
import AdminStatisticsNav from '@/routes/arc/-widgets/admin-statistics-nav/AdminStatisticsNav.tsx';

import PersonalStatistics from './-PersonalStatistics.tsx';
import TeamStatistics from './-TeamStatistics.tsx';

export const Route = createFileRoute('/arc/_sip/statistics')({
  component: StatisticsPage,
});

function StatisticsPage() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);
  const [timeRange, setTimeRange] = useState<
    'real-time' | 'day' | 'week' | 'month'
  >('real-time');

  return (
    <div className={'flex min-h-0 flex-1 flex-col'}>
      <AdminStatisticsNav />
      <div className={'flex min-h-0 flex-1 flex-col p-[10px]'}>
        <div className={'arc-card flex min-h-0 flex-1 flex-col'}>
          <div className={'flex gap-4 p-[10px]'}>
            <TagButton active={current === 0} onClick={() => setCurrent(0)}>
              {t('arc.statistics.personal')}
            </TagButton>
            <TagButton active={current === 1} onClick={() => setCurrent(1)}>
              {t('arc.statistics.team')}
            </TagButton>
            <div className="flex-1"></div>
            <Segmented
              value={timeRange}
              style={{ marginBottom: 8 }}
              onChange={setTimeRange}
              options={[
                {
                  label: t('arc.statistics.timeRange.realTime'),
                  value: 'real-time',
                },
                { label: t('arc.statistics.timeRange.day'), value: 'day' },
                { label: t('arc.statistics.timeRange.month'), value: 'month' },
              ]}
            />
          </div>
          <div className={'min-h-0 flex-1 overflow-y-auto'}>
            {current === 0 ? <PersonalStatistics /> : <TeamStatistics />}
          </div>
        </div>
      </div>
    </div>
  );
}
